import { render, staticRenderFns } from "./otp-modal.vue?vue&type=template&id=7f6aeee0"
import script from "./otp-modal.vue?vue&type=script&lang=js"
export * from "./otp-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports